import React from "react";

import { FormControlLabel, Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useAppDispatch, useAppSelector } from "store";
import { selectShowAlternateCategoryCompetitors, toggleShowAlternateCategoryCompetitors } from "modules/customer/insights/portfolioNew/competitionNew/competitionNewSlice";

const StyledSwitch = withStyles(theme => ({
    switchBase: {
        "&$checked": {
            // @ts-ignore
            color: theme.palette.tertiary.main,
        },
        "&$checked + $track": {
            // @ts-ignore
            backgroundColor: theme.palette.tertiary.main
        }
    },
    checked: {},
    track: {}
}))(Switch);

const AlternateCategoriesSwitch: React.FC = () => {
    const dispatch = useAppDispatch();
    const showAlternateCategoryCompetitors = useAppSelector(selectShowAlternateCategoryCompetitors);

    const onChange = () => {
        dispatch(toggleShowAlternateCategoryCompetitors());
    };

    const probabilitySwitch = (<StyledSwitch
        size="small"
        color="default"
        checked={showAlternateCategoryCompetitors}
        onChange={onChange}
    />);

    return (
        <FormControlLabel
            control={probabilitySwitch}
            label="Show alternate category stores"
        />

    );
};

export default AlternateCategoriesSwitch;
